import React, { useEffect, useState } from "react";

import CricketTable from "./CricketTable";
import TestMatchTabs from "./TestMatchTabs";
import InningsTabsAndTable from "./InningsTabsAndTable";
import { loadStyles } from "../../utils/cssLoader";

const CricketFallOfWickets = ({
  ServerData,
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData?.data;
  const [active, setActive] = useState(null);
  const [subActive, setSubActive] = useState(null);

  const homeTeamLineup = data?.[0];
  const awayTeamLineup = data?.[1];
  const homeTeamLineup2 = data?.[2];
  const awayTeamLineup2 = data?.[3];

  useEffect(() => {
    const hasSecondInningsHome = !!homeTeamLineup2;
    const hasSecondInningsAway = !!awayTeamLineup2;

    if (hasSecondInningsAway || awayTeamLineup) {
      setActive("away");
      setSubActive(hasSecondInningsAway ? "2nd innings" : "1st innings");
    } else if (hasSecondInningsHome || homeTeamLineup) {
      setActive("home");
      setSubActive(hasSecondInningsHome ? "2nd innings" : null);
    }
  }, [homeTeamLineup, awayTeamLineup, homeTeamLineup2, awayTeamLineup2]);

  const getScoreCardData = () => {
    if (active === "home") {
      return subActive === "1st innings"
        ? homeTeamLineup
        : homeTeamLineup2
          ? homeTeamLineup2
          : homeTeamLineup;
    }
    return subActive === "1st innings"
      ? awayTeamLineup
      : awayTeamLineup2
        ? awayTeamLineup2
        : awayTeamLineup;
  };
  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);
  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <TestMatchTabs
        items={[
          homeTeamLineup?.name && {
            value: "home",
            label: homeTeamLineup?.name,
          },
          awayTeamLineup?.name && {
            value: "away",
            label: awayTeamLineup?.name,
          },
        ].filter(Boolean)}
        activeItem={active}
        onClick={setActive}
        mainTab={true}
      />
      <div className="global_table cr_macth_scorecard fall_of_wickets">
        <table>
          <InningsTabsAndTable
            active={active}
            homeTeamLineup2={homeTeamLineup2}
            awayTeamLineup2={awayTeamLineup2}
            subActive={subActive}
            setSubActive={setSubActive}
          >
            <CricketTable data={getScoreCardData()} />
          </InningsTabsAndTable>
        </table>
      </div>
    </>
  );
};

export default CricketFallOfWickets;
